var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreePointSetings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.5C4 13.325 4.75 14 5.66667 14C6.58333 14 7.33333 13.325 7.33333 12.5C7.33333 11.675 6.58333 11 5.66667 11C4.75 11 4 11.675 4 12.5ZM15.6667 12.5C15.6667 13.325 16.4167 14 17.3333 14C18.25 14 19 13.325 19 12.5C19 11.675 18.25 11 17.3333 11C16.4167 11 15.6667 11.675 15.6667 12.5ZM9.83333 12.5C9.83333 13.325 10.5833 14 11.5 14C12.4167 14 13.1667 13.325 13.1667 12.5C13.1667 11.675 12.4167 11 11.5 11C10.5833 11 9.83333 11.675 9.83333 12.5Z",
    fill: "#75848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePointSetings);
export default __webpack_public_path__ + "static/media/threePointSetings.e8f1d26d76a99987aa3104a6875e71f8.svg";
export { ForwardRef as ReactComponent };